export default angular
  .module('doxy.common.filters.currentYear', [])
  .filter('currentYear', function () {
    return function () {
      return new Date().getFullYear();
    };
  }).name;
